// src/constants/statusMap.js (or wherever you keep it)

import { IoMdCloseCircle, IoMdCheckmarkCircle } from "react-icons/io";
import { FaCreditCard } from "react-icons/fa6";
import { STATUS_KEYS as STATUS } from "./statusKeys";

export const STATUS_MAP = {
  [STATUS.PAYMENT_PROCESSING]: {
    key: STATUS.PAYMENT_PROCESSING,
    title: "Processing your payment.",
    iconComponent: FaCreditCard,
    iconProps: { size: 150 },
    showLoader: true,
    image: null,
  },

  [STATUS.PAYMENT_SUCCESS]: {
    key: STATUS.PAYMENT_SUCCESS,
    title: "Payment successful!",
    iconComponent: IoMdCheckmarkCircle,
    iconProps: { className: "text-success", size: 150 },
    showLoader: true,
    image: null,
  },

  [STATUS.PAYMENT_FAILED]: {
    key: STATUS.PAYMENT_FAILED,
    title: "Payment failed. Please try again.",
    iconComponent: IoMdCloseCircle,
    iconProps: { className: "text-danger", size: 150 },
    showLoader: true,
    image: null,
  },

  [STATUS.PLUG_IN]: {
    key: STATUS.PLUG_IN,
    title: "Plug in your vehicle to begin charging.",
    iconComponent: null,
    iconProps: null,
    image: "/plugin.jpg",
    showLoader: false,
  },

  [STATUS.UNPLUG]: {
    key: STATUS.UNPLUG,
    title: "Unplug your vehicle.",
    iconComponent: null,
    iconProps: null,
    image: "/unplug.jpg",
    showLoader: false,
  },

  [STATUS.CHARGING_COMPLETE]: {
    key: STATUS.CHARGING_COMPLETE,
    title: "Charging complete! You may unplug your vehicle.",
    iconComponent: null,
    iconProps: null,
    image: "/unknown.jpg",
    showLoader: false,
  },

  [STATUS.UNKNOWN]: {
    key: STATUS.UNKNOWN,
    title: "Status unknown.",
    iconComponent: null,
    iconProps: null,
    image: "/unknown.jpg",
    showLoader: false,
  },
};